export default "__VITE_ASSET__owjgmFKF__"